import { useCallback, useEffect, useState } from "react";
import { createTeamSpaceForLead, getTeamSpaceForLead } from "../api/client";

export function useLeadTeamSpace(leadId, { enabled = true } = {}) {
  const [space, setSpace] = useState(null);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !leadId) {
      setSpace(null);
      setError(null);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    getTeamSpaceForLead(Number(leadId))
      .then((res) => {
        if (cancelled) return;
        const id = res?.id != null ? Number(res.id) : null;
        setSpace(id ? res : null);
      })
      .catch((err) => {
        if (cancelled) return;
        const status = Number(err?.status);
        // 401/403: sem permissão. Demais falhas (API antiga, rota nova ainda não no ar,
        // solicitação inexistente) não bloqueiam o compositor — o POST cria no envio.
        if (status === 401 || status === 403) {
          setError(err);
        } else {
          setError(null);
        }
        setSpace(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [leadId, enabled]);

  const ensureCreated = useCallback(async () => {
    if (space?.id != null) return space;
    const id = Number(leadId);
    if (!Number.isFinite(id) || id <= 0) return null;

    setCreating(true);
    setError(null);
    try {
      const created = await createTeamSpaceForLead(id);
      const createdId = created?.id != null ? Number(created.id) : null;
      const next = createdId ? created : null;
      setSpace(next);
      return next;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setCreating(false);
    }
  }, [space, leadId]);

  return {
    space,
    spaceId: space?.id != null ? Number(space.id) : null,
    loading,
    creating,
    error,
    ensureCreated,
    setSpace,
  };
}
